import React from 'react';

const PopularDestinations: React.FC = () => {
  const destinations = [
    {
      name: "Paris",
      country: "France",
      image: "paris",
      description: "The City of Light"
    },
    {
      name: "Tokyo",
      country: "Japan",
      image: "tokyo",
      description: "Modern meets traditional"
    },
    {
      name: "New York",
      country: "USA",
      image: "newyork",
      description: "The city that never sleeps"
    },
    {
      name: "Bali",
      country: "Indonesia",
      image: "bali",
      description: "Tropical paradise"
    },
    {
      name: "London",
      country: "UK",
      image: "london",
      description: "Historic charm"
    },
    {
      name: "Dubai",
      country: "UAE",
      image: "dubai",
      description: "Luxury and adventure"
    }
  ];

  return (
    <section className="popular-destinations">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Popular Destinations</h2>
          <p className="section-subtitle">
            Discover the world's most loved travel destinations
          </p>
        </div>
        <div className="destinations-grid">
          {destinations.map((destination, index) => (
            <div key={index} className="destination-card">
              <div className={`destination-image ${destination.image}`}></div>
              <div className="destination-content">
                <h3 className="destination-name">{destination.name}</h3>
                <p className="destination-country">{destination.country}</p>
                <p className="destination-description">{destination.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularDestinations; 